module.exports = __webpack_public_path__ + "staticcomp/img/share.b2c7ef4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/9/share.jpg
// module id = Sx5/
// module chunks = 39